import axios from "axios";
export const BASEURL = {
  // ENDPOINT_URL: "http://localhost:5200/",
  ENDPOINT_URL: "https://shoperschoiceapi.theshoperschoice.com/",
};
const AuthToken = sessionStorage.getItem("Authtoken");
// console.log(AuthToken);
export default axios.create({
  baseURL: `${BASEURL.ENDPOINT_URL}api`,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    Authorization: `Bearer ${AuthToken}`,
  },
});
// console.log(localStorage.getItem("token"));
